class ProgramSelectWatcher {
	constructor() {
		this.programSelect = document.querySelector("#program-select");
		if (this.programSelect) {
			this.run();
		}
	}

	run() {
		this.programSelect.addEventListener("change", (event) => {
			console.log(event);
			const option = this.programSelect.querySelector(`option[value="${event.target.value}"]`);
			const target = option.getAttribute("data-target");
			console.log(option);

			if (target === "_blank") {
				window.open(event.target.value, option.getAttribute("data-target"));
			} else {
				window.location.href = event.target.value;
			}
		});
	}
}

export default ProgramSelectWatcher;
